import instance from "./Request";

export const getAllParams = async (config) => {
  const request = await instance();
  let data = await request.post("/settings/all", config).catch((error) => {
    return {
      error,
    };
  });
  return data;
};

export const sendAllParams = async (values) => {
  const request = await instance();
  let data = await request.post("/settings/saveall", values).catch((error) => {
    return {
      error,
    };
  });
  return data;
}

export const getVoucheriData = async (config) => {
    const request = await instance();
    let data = await request.post("/settings/voucherify", config).catch((error) => {
      return {
        error,
      };
    });
    return data;
  };

export const getParam = async (param) => {
  const request = await instance();
  let data = await request
    .post("/settings/param", param)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};

export const setParam = async (param) => {
  const request = await instance();
  let data = await request
    .post("/settings/update-param", param)
    .catch((error) => {
      return {
        error,
      };
    });
  return data;
};
